import { NgModule } from '@angular/core';
import { IccEligibleProviderImportsService } from '../core/services/icc/icc-eligible-provider-imports.service';
import { IccMedicaidCodeImportsService } from '../core/services/icc/icc-medicaid-code-imports.service';
import { IccIneligibleDrugImportsService } from '../core/services/icc/icc-ineligible-drug-imports.service';
import { IccCatalogedDrugImportsService } from '../core/services/icc/icc-cataloged-drug-imports.service';
import { IccOrphanExemptionDrugImportsService } from '../core/services/icc/icc-orphan-exemption-drug-imports.service';
import { IccPharmacyImportsService } from '../core/services/icc/icc-pharmacy-imports.service';
import { IccClaimImportsService } from '../core/services/icc/icc-claim-imports.service';
import { IccCaptureEligibilityFindingsImportsService } from '../core/services/icc/icc-capture-eligibility-findings-imports.service';

@NgModule({
  providers: [
    IccEligibleProviderImportsService,
    IccMedicaidCodeImportsService,
    IccIneligibleDrugImportsService,
    IccCatalogedDrugImportsService,
    IccOrphanExemptionDrugImportsService,
    IccPharmacyImportsService,
    IccClaimImportsService,
    IccCaptureEligibilityFindingsImportsService,
  ],
})
export class IccModule {}
